import React from "react";
import { ListTree } from "lucide-react";
import GlobalDetailDrawer from "modules/swiftboard/components/GlobalDetailDrawer";
import LocalDateTime from "services/date-converter";
import ActiveBadge from "../../../components/ActiveBadge";
import JsonBlock from "../../../components/JsonBlock";
import { DATA_TYPE_LABEL, FIELD_ROLE_LABEL } from "../../../features/builder.constants";
import { FORMAT_LABEL } from "../features/source-field.constants";
import { computeSummary } from "../features/source-field.utils";

const yesNo = (value) => (value ? "Yes" : "No");

// Read-only view of one field (a row of the grid, as saved).
export default function FieldViewDrawer({ record, onClose }) {
  const sections = [
    {
      title: "Field",
      fields: [
        { label: "Label", value: record.label || "—" },
        { label: "Field key", value: <span className="font-mono">{record.field_key}</span> },
        { label: "Reads", value: record.path ? <span className="font-mono">{record.path}</span> : `Computed: ${computeSummary(record.compute)}` },
        { label: "Data type", value: DATA_TYPE_LABEL[record.data_type] ?? record.data_type },
        { label: "Role", value: FIELD_ROLE_LABEL[record.field_role] ?? record.field_role },
        { label: "Format", value: FORMAT_LABEL[record.format] ?? "—" },
        { label: "Values", value: (record.enum_values ?? []).join(", ") || "—" },
        { label: "Can be filtered", value: yesNo(record.is_filterable) },
        { label: "Template variable", value: yesNo(record.is_template_var) },
        { label: "Sensitive", value: yesNo(record.is_sensitive) },
        { label: "Sort order", value: record.sort_order ?? 0 },
        { label: "Status", value: <ActiveBadge active={record.is_activated} /> },
        { label: "Updated", value: record.updated_date ? <LocalDateTime utcTime={record.updated_date} /> : "—" },
        { label: "Description", value: record.description || "—" },
      ],
    },
    ...(record.compute ? [{ title: "Calculation", fields: [{ value: <JsonBlock value={record.compute} /> }] }] : []),
  ];

  return <GlobalDetailDrawer open onClose={onClose} title={record.label || record.field_key} subtitle={record.field_key} icon={<ListTree size={20} />} sections={sections} />;
}
